export const LOCAL_STORAGE_QUERY_PARAMS = [
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_content',
  'utm_term',
  'var9',
];

export const TRACKING = { UTM_TRACKING: 'utmTracking' };
